import { render, staticRenderFns } from "./Dependent.vue?vue&type=template&id=24251068"
import script from "./Dependent.vue?vue&type=script&lang=js"
export * from "./Dependent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports